import React, { useEffect, useState } from 'react'
import './dashboard.css'
import {
   AtenyaImage,
   BigLogo,
   CoverImg,
   FollowersIcon,
   InfoIcon,
   LinkArrowIcon,
   Logo,
   PalyListIcon,
   UserImage,
   ViewsIcon
} from 'assets'
import SentimentScore from './components/SentimentScore'
import EmotionsScore from './components/EmotionsScore'
import VideoSection from './components/VideoSection'
import LineChart from './components/LineChart'
import SentimentChart from './components/SentimentChart'
import { CustomModal, Loader } from 'components'
import { useDispatch, useSelector } from 'react-redux'
import { createImageUrl } from 'utils/createImageUrl'
import dayjs from 'dayjs'
import { formatNumber } from 'utils/formatNumber'
import { getChannelDetailsAction, resetChannelInfoStatus } from 'store/action/settingsReducer'
import { resetLoadMoreCommentsStatus } from 'store/action/videoReducer'

function Dashboard() {
   const settingData = useSelector((state) => state.settings)
   const { channelDetails, loading, selectedChannelID, channelDetailsLoading } = settingData
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loadMoreComments } = videoRedux
   const authData = useSelector((state) => state.user)
   const { isDashboard } = authData
   const [showMore, setShowMore] = useState(false)
   const [isLongText, setIsLongText] = useState(false)
   const [openShowMoreModal, setOpenShowMoreModal] = useState(false)
   const dispatch = useDispatch()

   const onCloseModal = () => {
      setOpenShowMoreModal(!openShowMoreModal)
   }

   useEffect(() => {
      if (selectedChannelID) {
         if (!isDashboard) {
            dispatch(getChannelDetailsAction({ channel_id: selectedChannelID }))
         }
      } else {
         dispatch(resetChannelInfoStatus())
      }
      return () => {}
   }, [selectedChannelID])

   useEffect(() => {
      if (channelDetails?.description) {
         setIsLongText(channelDetails?.description?.length > 250)
      }
      return () => {}
   }, [channelDetails])

   useEffect(() => {
      if (loadMoreComments) {
         dispatch(resetLoadMoreCommentsStatus())
      }
      return () => {}
   }, [loadMoreComments])

   return (
      <>
         {(loading || channelDetailsLoading) && <Loader />}
         <div className="dashboard-layouts">
            <div className="card pb-0">
               <div className="channel-section">
                  <div className="channel-cover-image">
                     {!loading && !channelDetailsLoading && (
                        <img
                           src={
                              channelDetails?.banner ? createImageUrl(channelDetails?.banner) : null //AtenyaImage
                           }
                           onError={(e) => {
                              e.target.onerror = null // Prevent infinite loop if fallback also fails
                              e.target.src = AtenyaImage
                           }}
                           alt="cover photo"
                        />
                     )}
                  </div>
                  <div className="channel-details-wrap">
                     <div className="channel-image">
                        {channelDetails?.logo ? (
                           <img src={createImageUrl(channelDetails?.logo)} alt="channel-image" />
                        ) : (
                           !loading && !channelDetailsLoading && null // <img src={BigLogo} alt="channel-image" />
                        )}
                     </div>
                     <div className="channel-desc">
                        <div className="channel-name-section">
                           <div className=" ch-name-wrap">
                              <h3 className="at-text-dark">{channelDetails?.channel_name}</h3>
                              <p
                                 className="at-text-light"
                                 style={{ fontSize: '12px', color: '#FF423D' }}>
                                 {channelDetails?.creation_date
                                    ? dayjs(channelDetails?.creation_date).format('D MMMM, YYYY')
                                    : ''}
                              </p>
                           </div>
                           {channelDetails?.channel_url && (
                              <div
                                 className="channel-btn"
                                 onClick={() => {
                                    channelDetails?.channel_url &&
                                       window.open(channelDetails?.channel_url)
                                 }}>
                                 <span>View Channel</span>
                                 <LinkArrowIcon />
                              </div>
                           )}
                        </div>
                        <p className="mt-2 at-text-light" style={{ fontWeight: '400' }}>
                           {(channelDetails?.description && showMore) || !isLongText ? (
                              channelDetails?.description
                           ) : (
                              <>
                                 {channelDetails?.description?.substring(0, 200)}
                                 <span
                                    className="show-more-text"
                                    onClick={() => {
                                       setOpenShowMoreModal(true)
                                    }}>
                                    ...Show more
                                 </span>
                              </>
                           )}
                        </p>
                        <div className="channel-counter mt-3 mb-3">
                           <div className="row">
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <FollowersIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(
                                                channelDetails?.total_subscriber_count || 0,
                                                2
                                             )}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             subscribers
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <ViewsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {' '}
                                             {formatNumber(
                                                channelDetails?.total_view_count || 0,
                                                2
                                             )}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             VIEWS
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <PalyListIcon className="paly-list-icon" />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(channelDetails?.total_video || 0, 2)}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             Total Videos
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               
            </div>
            <div className="row mt-3">
               <div className="col-12 col-lg-6 col-xl-4">
                  <SentimentScore />
               </div>
               <div className="col-12 col-lg-6 col-xl-8">
                  <EmotionsScore />
               </div>
            </div>
            {/*  */}
            <div className="sentiment-chart mt-4">
               <SentimentChart />
            </div>
            <div className="video-section mt-3">
               <VideoSection />
            </div>
         </div>
         {openShowMoreModal && (
            <CustomModal
               show={openShowMoreModal}
               title={'Description'}
               closeModal={onCloseModal}
               centered
               scrollable
               size={'lg'}>
               <div>{channelDetails?.description}</div>
            </CustomModal>
         )}
      </>
   )
}

export default Dashboard
